import apiBase from 'api/base';

export const getProviderTransactions = (providerId, page) =>
  apiBase.get(`/admin/providers/${providerId}/transactions?page=${page}&items=20`);

export const getTransactions = page => apiBase.get(`/transactions?page=${page}&items=20`);

export const getMyTransactions = page => apiBase.get(`/me/transactions?page=${page}&items=20`);
